var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 2.00154C15.2239 2.00051 15.1978 2 15.1716 2H9C7.89543 2 7 2.89543 7 4V17C7 18.1046 7.89543 19 9 19H19C20.1046 19 21 18.1046 21 17V7.82843C21 7.80223 20.9995 7.77608 20.9985 7.75H17C16.0335 7.75 15.25 6.9665 15.25 6V2.00154ZM20.25 6.25L16.75 2.75V6C16.75 6.13807 16.8619 6.25 17 6.25H20.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.06299V17C5.5 18.933 7.067 20.5 9 20.5H17.937C17.715 21.3626 16.9319 22 16 22H8C5.79086 22 4 20.2091 4 18V5.99998C4 5.06806 4.63739 4.28501 5.5 4.06299Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyAlt);
export default __webpack_public_path__ + "static/media/copy-alt.ef5026d6204b7b4761e02e947fc63006.svg";
export { ForwardRef as ReactComponent };